// **************************************************
// Load more
// **************************************************
const cardListElem = document.querySelector('.card-list__item');
const loadMoreButton = document.querySelector('.card-list__footer .more-link');

const cardListLoadMoraAction = () => {
  attachEvent('.card-list__footer .more-link', 'click', (ev) => {
    const hiddenItems = document.querySelectorAll('.card-list__item.hide');
    toggleHideClass(loadMoreButton, false);
    hiddenItems.forEach((el, i) => {
      const remainingItems = document.querySelectorAll('.card-list__item.hide');
      if (i < 8) {
        toggleHideClass(el, false);
      }

      if (remainingItems.length === 1) {
        toggleHideClass(loadMoreButton, true);
      }
    });
  });
};

if (cardListElem) {
  cardListLoadMoraAction();
}
